import { formatDateTime } from '@myap/ui-library/esm/date'
import { Error, Loader, SortableTable, BasicText } from '../common'
import { fetchRefundedExams } from '../../actions/refundExam'
import {
  getExamsForRefundSubmissionStatus,
  getRefundedExamsData,
  getRefundedExamsStatusProps,
} from '../../selectors/refundExam'
import { generateShortUID } from '../../utils/common'
import tableUtilStyles from '../../assets/style/scss/table-utils.scss'

const mapStateToProps = state => {
  const { fetched: submitted } = getExamsForRefundSubmissionStatus(state)
  const { fetching, fetched, error } = getRefundedExamsStatusProps(state)
  const data = getRefundedExamsData(state)
  return {
    submitted,
    fetching,
    fetched,
    error,
    data,
  }
}

const StandardRow = ({
  data: { studentId, testingAiCode, courseName, refundedOn, refundedBy, academicYear },
  index,
}) => (
  <tr className={`${index % 2 ? tableUtilStyles.even : tableUtilStyles.odd}`}>
    <th scope="row">{studentId}</th>
    <td>{testingAiCode}</td>
    <td>{courseName}</td>
    <td>{formatDateTime(refundedOn)}</td>
    <td>{refundedBy}</td>
    <td>{academicYear}</td>
  </tr>
)

const virtualRow = ({ data, index }) => (
  <tr className={`${index % 2 ? tableUtilStyles.even : tableUtilStyles.odd}`}>
    <th scope="row">{data[index].studentId}</th>
    <td>{data[index].testingAiCode}</td>
    <td>{data[index].courseName}</td>
    <td>{formatDateTime(data[index].refundedOn)}</td>
    <td>{data[index].refundedBy}</td>
    <td>{data[index].academicYear}</td>
  </tr>
)

export default connect(mapStateToProps, { fetchRefundedExams })(
  ({ submitted, fetching, error, data, fetchRefundedExams }) => {
    const [filterAiCode, setFilterAiCode] = useState('')
    const [visibleData, setVisibleData] = useState([])

    const headerColumns = [
      {
        headerText: { title: 'AP ID' },
        headerAttributes: { id: 'studentId' },
      },
      {
        headerText: { title: 'Testing AI' },
        headerAttributes: { id: 'testingAiCodeCol' },
        key: ['testingAiCode'],
        sortDir: ['asc'],
      },
      {
        headerText: { title: 'Course Name' },
        headerAttributes: { id: 'courseNameCol' },
      },
      {
        headerText: { title: 'Refunded On' },
        headerAttributes: { id: 'refundedDateCol' },
        key: ['refundedOn'],
        sortDir: ['desc'],
        defaultSort: true,
      },
      {
        headerText: { title: 'Refunded By' },
        headerAttributes: { id: 'createdByCol' },
        key: ['refundedBy'],
        sortDir: ['asc'],
      },
      {
        headerText: { title: 'Academic Year' },
        headerAttributes: { id: 'academicYearCol' },
        key: ['academicYear'],
        sortDir: ['desc'],
      },
    ]

    useEffect(() => {
      fetchRefundedExams()
    }, [submitted])

    useEffect(() => {
      if (filterAiCode.length > 0) {
        setVisibleData(data.filter(item => item?.testingAiCode.startsWith(filterAiCode)))
      } else {
        setVisibleData(data)
      }
    }, [filterAiCode, data])

    const handleChangeAiCodeFilter = e => {
      setFilterAiCode(e.target.value)
    }

    if (error) return <Error message={error} />

    if (fetching) return <Loader />

    if (data.length > 0)
      return (
        <>
          <div className="row">
            <div className="col-md-4 col-sm-12 cb-spacerv-sm-top">
              <h2 className="cb-spacerv-xs-top">Refunded Exams</h2>
            </div>
            <div className="col-md-8 col-sm-12 cb-spacerv-sm-top">
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <div style={{ width: '200px' }}>
                  <BasicText
                    name="aiCodeFilter"
                    value={filterAiCode}
                    srOnlyLabel={true}
                    placeholder="AI Code"
                    maxlength="8"
                    isSearchBox={true}
                    input={{
                      name: 'filterAiCode',
                      value: filterAiCode,
                      onChange: e => handleChangeAiCodeFilter(e),
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              {visibleData.length === 0 && data.length > 0 ? (
                <p>There are no refunds that match the selected filters.</p>
              ) : (
                <SortableTable
                  tableAttributes={{
                    id: 'refundedTable',
                    summary:
                      'Table listing all student exams that have been refunded. By default, most recently refunded exam is first.',
                    className: `table cb-no-table-border ${tableUtilStyles['som-striped']}`,
                  }}
                  data={visibleData}
                  virtualRow={virtualRow}
                  StandardRow={StandardRow}
                  columns={headerColumns}
                  tableCaption={{
                    caption: 'A view of refunded student exams.',
                    srOnly: true,
                  }}
                  virtualKey={(index, data) => {
                    return `${data[index].studentId}_${data[index].testCd}_${generateShortUID()}`
                  }}
                  standardKey={data => {
                    return `${data.studentId}_${data.testCd}_${generateShortUID()}`
                  }}
                  itemSize={49}
                />
              )}
            </div>
          </div>
        </>
      )

    return (
      <div className="row">
        <div className="col-xs-12 cb-spacerv-sm-top">
          <p>No exams have been refunded yet.</p>
        </div>
      </div>
    )
  }
)
